import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';
import * as fmt from '../lib/format';

// One quiet line: when the portal's copy of Jira was last brought up to date, so a lead knows how fresh the numbers are
// before sending a report. It reads on its own; if it cannot be read it says nothing rather than something wrong.
export default function FreshnessNote({ className = '' }: { className?: string }) {
  const [at, setAt] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    apiService
      .getFreshness()
      .then((r) => !cancelled && setAt(r.success ? r.data.issues_updated_at : undefined))
      .catch(() => !cancelled && setAt(undefined));
    return () => {
      cancelled = true;
    };
  }, []);

  if (at === undefined) return null;
  return (
    <p className={`text-sm text-gray-600 print:hidden ${className}`} role="status">
      {at === null ? 'The portal has not updated from Jira yet. An admin can do it in Settings → Update data.' : `Jira data last updated ${fmt.dateTime(at)}.`}
    </p>
  );
}
